import {Injectable} from "@angular/core";
import {MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {CustomDialogComponent} from "../forms/custom-dialog/custom-dialog.component";
import {CustomDialogConfig} from "./form-dialog.service";

@Injectable({providedIn:'root'})
export class CustomDialogService {
    public dialogRef: MatDialogRef<CustomDialogComponent>;

    constructor(public dialog: MatDialog) {
    }

    openCustomDialog(event: any, config: CustomDialogConfig, panel_class: string,
                     setStyles?: (event) => void, selectionChanged?: (event) => void): MatDialogRef<CustomDialogComponent> {
        event?.stopPropagation();
        const dialogConfig = new MatDialogConfig();
        dialogConfig.id = "custom-dialog";
        dialogConfig.backdropClass = 'transparent-backdrop';
        dialogConfig.disableClose = false;
        dialogConfig.data = {
            positionRelativeToElement: event?.target,
            config: config,
            setStyles: setStyles,
            selectionChanged: selectionChanged
        };
        dialogConfig.panelClass = panel_class;
        return this.dialog.open(CustomDialogComponent, dialogConfig);
    }
}
